import BaseApi from './BaseApi';

export interface ITags {
    get(clientNumber: number, projectNumber: number, jwt: string): Promise<object>;
}

export default class Tags extends BaseApi implements ITags {
    constructor(baseUrl: string) {
        super(baseUrl);
    }
    get = (clientNumber: number, projectNumber: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/tags`, jwt);
    };
}



// WEBPACK FOOTER //
// ./src/api/Tags.ts